import * as Yup from "yup";

export const SignUpValidationSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Enter a valid email")
    .required("Email Required"),
  password: Yup.string("Enter your password")
    .trim()
    .required("Password Required")
    .min(8),
  providerId: Yup.string()
    .trim()
    .required("Please Select an organization you are affiliated to."),
  affiliation: Yup.string().trim().required("This field is required"),
  referralCode: Yup.string().trim(),
});

export const SignInValidationSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Enter a valid email")
    .required("Email Required"),
  password: Yup.string("Select your password")
    .trim()
    .required("Password Required")
    .min(8),
});

export const pageTwoValidationSchema = Yup.object({
  firstName: Yup.string("Enter your first Name")
    .trim()
    .matches(/^[-a-zA-ZÀ-ÿ]+$/, {
      message:
        "Only letters and hyphens are allowed in your first name",
      excludeEmptyString: true,
    })
    .required("First Name is Required"),
  lastName: Yup.string("Enter your last Name")
    .trim()
    .matches(/^[-a-zA-ZÀ-ÿ]+$/, {
      message:
        "Only letters and hyphens are allowed in your last name",
      excludeEmptyString: true,
    })
    .required("lastName Name is Required"),
  specialization: Yup.string("Select your Specialization")
    .trim()
    .required("Specialization is Required"),
  gender: Yup.string("Select your gender").required("Gender is Required"),
  picture: Yup.string("Upload a single Image")
    .required("Image is required")
    .typeError("Image is required"),
  dob: Yup.date("Enter your DOB")
    .typeError("Please select a valid date")
    .required("DOB is Required"),
  phoneNumber: Yup.string("Enter your Phone Number")
    .matches(
      /^(\+234|0)?[789]\d{9}$/,
      "Please enter a valid Nigerian phone number"
    )
    .required("Phone Number is Required"),
  cadre: Yup.string("Enter your Level").trim().required("Level is Required"),
});

export const FormValidationSchema = Yup.object({
  degreeImage: Yup.string()
    .trim()
    .typeError("Please upload a valid degree image"),
  license: Yup.string()
    .trim()
    .typeError("Please enter a valid license number")
    .required("License number is required."),
  expire: Yup.date()
    .typeError("Please enter a valid expiry date")
    .required("Provide an expiry date for your license."),
  licenseImage: Yup.string()
    .trim()
    .typeError("Please upload a valid image of your license")
    .required("Provide an image of your license"),
  year: Yup.date()
    .typeError("Please enter a valid graduation year")
    .nullable(),
  gYear: Yup.date()
    .typeError("Please enter a valid year book date")
    .nullable(),
  licenseType: Yup.string()
    .trim()
    .typeError("Please select a valid license type")
    .required("Type of license is required."),
  gImage: Yup.string()
    .trim()
    .typeError("Please upload a valid yearbook image"),
  InstagramName: Yup.string()
    .trim()
    .typeError("Please enter a valid Instagram handle"),
  FacebookName: Yup.string()
    .trim()
    .typeError("Please enter a valid Facebook group name"),
  degree: Yup.string().trim().typeError("Please enter a valid degree"),
  doctorInstitution: Yup.string()
    .trim()
    .typeError("Please enter a valid institution name"),
  doctorPosition: Yup.string()
    .trim()
    .typeError("Please enter a valid position"),
  doctorEmail: Yup.string()
    .trim()
    .email("Please enter a valid email address")
    .typeError("Please enter a valid email address"),
  referenceCode: Yup.string()
    .trim()
    .typeError("Please select a valid reference"),
  doctorName: Yup.string().trim().typeError("Please enter a valid name"),
});
